<template>
    <div class="delivery-management">
        <!-- 近期数据 -->
        <div class="delivery-management_recently">
            <div class="recently-header">
                <div class="header-top">
                    <div class="top-left">
                        <span class="title">在投订单</span>

                        <span class="data-title">近期数据</span>
                    </div>

                    <div class="top-right">视频订单 <i class="el-icon-caret-bottom"></i></div>
                </div>

                <div class="header-bottom">{{ getDatePickLabel }} <i class="el-icon-caret-bottom"></i></div>
            </div>

            <div class="recently-data">
                <div class="data-item" v-for="(item, index) in centerData" :key="index">
                    <div class="data-item_value">{{ item.value }}{{ item.unit ? item.unit : "" }}</div>

                    <div class="data-item_label">{{ item.label }}</div>
                </div>
            </div>

            <div class="recently-center">
                查看DOU+数据中心
                <i class="el-icon el-icon-arrow-right"></i>
            </div>
        </div>

        <!-- 状态选择 -->
        <div class="delivery-management_status" v-draggle-scroll-x>
            <div
                :class="['status-item', { 'is-check': currentStatus === item }]"
                v-for="item in status"
                :key="item"
                @click="currentStatus = item"
            >
                {{ item }}
            </div>
        </div>

        <!-- 视频列表 -->
        <div class="delivery-management_video">
            <div class="video-item" v-for="item in getVideoList" :key="item.id">
                <div class="video-item_header">
                    <div class="header-status">
                        <img src="@/assets/icons/correct-icon.svg" alt="" />
                        <span>投放完成</span>
                    </div>

                    <div class="header-data">
                        <div class="data-play">{{ item.target }} ￥{{ item.money }}</div>

                        <div class="data-split"></div>

                        <div class="data-date">
                            {{ getDateLabel }}
                        </div>
                    </div>
                </div>

                <div class="video-item_info">
                    <img :src="getImgSrc(item.img)" alt="" class="info-img" />

                    <div class="info-detail">
                        <div class="info-title">
                            {{ item.title }}
                        </div>

                        <div class="info-user">{{ item.user }}的抖音视频</div>
                    </div>
                </div>

                <div class="video-item_data">
                    <div class="data-detail">
                        <div class="detail-item">
                            <div class="item-label">播放量</div>
                            <div class="item-value">{{ item.effect.play }}</div>
                        </div>

                        <div class="detail-item">
                            <div class="item-label">点赞量</div>
                            <div class="item-value">{{ item.effect.digg }}</div>
                        </div>

                        <div class="detail-item">
                            <div class="item-label">粉丝量</div>
                            <div class="item-value">{{ item.effect.fan }}</div>
                        </div>
                    </div>

                    <div class="data-button" @click="handleToDetail(item)">查看详情</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { draggleScrollX } from "@/utils/directives.js";
import videoJson from "@/utils/training-data/video.json";

export default {
    name: "DeliveryManagement",
    data() {
        return {
            centerData: [
                { label: "预算", value: 0 },
                { label: "消耗", value: 0 },
                { label: "播放量", value: 0 },
                { label: "点赞量", value: 0 },
                { label: "评论量", value: 0 },
                { label: "分享量", value: 0 },
                { label: "主页浏览量", value: 0 },
                { label: "粉丝量", value: 0 },
                { label: "5s完播率", value: 0, unit: "%" },
            ],
            status: ["全部", "未支付", "审核中", "审核未通过", "审核暂停", "投放中", "投放完成", "投放终止", "待开播"],
            currentStatus: "全部",
            videoList: videoJson,
        };
    },
    computed: {
        getDateLabel() {
            const now = new Date();

            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, "0"); // 月份从 0 开始，需要 +1
            const day = String(now.getDate()).padStart(2, "0");
            const hours = String(now.getHours()).padStart(2, "0");
            const minutes = String(now.getMinutes()).padStart(2, "0");

            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },

        getDatePickLabel() {
            const nowDate = new Date();
            const prevDate = new Date(new Date().setDate(nowDate.getDate() - 7));

            const nowDateLabel = {
                year: nowDate.getFullYear(),
                month: String(nowDate.getMonth() + 1).padStart(2, "0"),
                day: String(nowDate.getDate()).padStart(2, "0"),
            };

            const prevDateLabel = {
                year: prevDate.getFullYear(),
                month: String(prevDate.getMonth() + 1).padStart(2, "0"),
                day: String(prevDate.getDate()).padStart(2, "0"),
            };

            const nowLabel = `${nowDateLabel.year}.${nowDateLabel.month}.${nowDateLabel.day}`;
            const prevLabel = `${prevDateLabel.year}.${prevDateLabel.month}.${prevDateLabel.day}`;

            return `${nowLabel}-${prevLabel}`;
        },

        getVideoList() {
            const data_type = Number(this.$route.query.data_type);

            const type = data_type === 15 ? 1 : 2;
            return this.videoList.filter((item) => item.type === type);
        },
    },
    directives: {
        draggleScrollX: draggleScrollX,
    },
    methods: {
        getImgSrc(name) {
            return require(`@/assets/images/training/${name}`);
        },

        handleToDetail(video) {
            this.$router.push({
                path: "/training/dou/delivery/detail",
                query: {
                    type: video.type,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.delivery-management {
    width: 100%;
    padding: 12px;
    box-sizing: border-box;
    font-family: PingFang-FC;
    color: #323233;

    &_recently {
        background-color: #ffffff;
        padding: 12px;
        border-radius: 12px;
        box-sizing: border-box;
        width: 100%;

        .recently-header {
            .header-top {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .top-left {
                    color: #999999;
                    font-size: 16px;
                    font-weight: 600;

                    .data-title {
                        color: #fc2b55;
                        margin-left: 10px;
                    }
                }

                .top-right {
                    font-size: 12px;
                    cursor: pointer;
                }
            }

            .header-bottom {
                margin-top: 4px;
                font-size: 12px;
                color: #999999;
                cursor: pointer;
            }
        }

        .recently-data {
            margin-bottom: 12px;
            display: flex;
            flex-wrap: wrap;

            .data-item {
                width: calc(100% / 3);
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                gap: 4px;
                font-size: 14px;
                height: 80px;
                font-weight: 500;

                &_value {
                    font-weight: 600;
                    font-size: 24px;
                }
            }
        }

        .recently-center {
            background-color: #fff3f5;
            height: 36px;
            line-height: 36px;
            color: #fc2b55;
            text-align: center;
            cursor: pointer;
        }
    }

    &_status {
        display: flex;
        gap: 10px;
        width: 100%;
        flex-wrap: nowrap;
        margin-top: 16px;

        .status-item {
            padding: 4px 16px;
            border-radius: 2px;
            background-color: #ffffff;
            flex-shrink: 0;
            font-size: 14px;
            cursor: pointer;

            &.is-check {
                color: #fc2b55;
            }
        }
    }

    &_video {
        .video-item {
            background-color: #ffffff;
            padding: 12px;
            border-radius: 6px;
            margin-top: 16px;

            &_header {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .header-status {
                    display: flex;
                    align-items: center;
                    gap: 6px;

                    img {
                        width: 16px;
                        height: 16px;
                        object-fit: cover;
                    }
                    span {
                        font-size: 12px;
                    }
                }

                .header-data {
                    font-size: 12px;
                    color: #999999;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .data-split {
                        height: 12px;
                        width: 1px;
                        background-color: #999999;
                        margin-inline: 6px;
                    }
                }
            }

            &_info {
                margin-top: 16px;

                display: flex;
                gap: 10px;

                .info-img {
                    width: 60px;
                    height: 60px;
                    object-fit: cover;
                    border-radius: 4px;
                }

                .info-detail {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width: calc(100% - 70px);
                    font-size: 13px;
                    color: #333333;

                    .info-title {
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2; /* 限制最多显示2行 */
                        overflow: hidden;
                        text-overflow: ellipsis;
                        word-break: break-word; /* 避免长单词溢出 */
                    }

                    .info-user {
                        font-size: 12px;
                        color: #999999;
                    }
                }
            }

            &_data {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 16px;

                .data-detail {
                    display: flex;
                    gap: 20px;

                    .detail-item {
                        font-size: 13px;
                        color: #333333;

                        .item-label {
                            color: #999999;
                        }

                        .item-value {
                            font-size: 16px;
                            font-weight: 600;
                        }
                    }
                }

                .data-button {
                    background-color: #fc2b55;
                    color: #ffffff;
                    padding: 6px 16px;
                    border-radius: 4px;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>
